import LightGallery from 'lightgallery/react';
import lgVideo from 'lightgallery/plugins/video';
import React, { useState, useEffect } from 'react';
import VideoThumbnail from 'assets/video_thumbnail.png';
import { Text } from 'theme-ui';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-video.css';
import 'lightgallery/css/lg-thumbnail.css';


export default function VideoClipGallery(props) {
    const rawClips = props.videoClips
    const thumbnails = props.thumbnails
    const [clips, setClips] = useState();

    useEffect(() => {
        let clipTags = []
        for (let i = 0; i < rawClips.length; i++) {
            var thumbnailSrc = VideoThumbnail.src
            if (thumbnails.length > 0) {
                thumbnailSrc = thumbnails[0].thumbnailSource.source
                if (thumbnails.length > i) {
                    thumbnailSrc = thumbnails[i].thumbnailSource.source
                }
            }
            var src = '{"source": [{"src":"' + rawClips[i].clipContent.source + '", "type":"video/mp4"}], "attributes": {"preload": false, "controls": true}}'
            clipTags.push(
                <a key={i} data-video={src} class="overlay-play-button" style={{ cursor: 'pointer', marginTop: 1 + 'px', marginRight: 10 + 'px', overflow: 'hidden', display: 'inline-block' }}>
                    <img src={thumbnailSrc} style={{ filter: 'blur(2px)' }} />
                    <div class="overlay-play-button__overlay">
                        <div class="overlay-play-button__play"><div class="triangle triangle--r triangle--sm"></div></div>
                    </div>
                </a>
            )
        }
        setClips(clipTags)
    }, [])

    const onInit = () => {

    };

    return (
        <>
            <Text
                as="p"
                sx={{
                    variant: 'sectionHeader.subTitle',
                    color: 'heading',
                    opacity: 1,
                }}
            >
                Video Clips
            </Text>

            <div style={{ lineHeight: 2 + 'px', textAlign: "center" }}>
                <LightGallery
                    licenseKey='513A96E2-744F44B0-810C09A0-AE2A1F4D'
                    onInit={onInit}
                    download={false}
                    plugins={[lgVideo]}>
                    {clips}
                </LightGallery>
            </div>
        </>

    );
}